import { NativeModule, registerWebModule } from 'expo-modules-core'
import { BrillenSdkModuleType, ResultEventPayload } from './BrillenSdk.types'
import { MeasurementType, openPlaceholderUi } from './useSdkModuleStorage'
import { Platform } from 'react-native'

type BrillenSDKModuleEvents = {
  onResult(event: ResultEventPayload): void
}

class MockSdk extends NativeModule<BrillenSDKModuleEvents> {
  prepare = () => undefined
  async showView(type: MeasurementType) {
    openPlaceholderUi(type)
  }
}

const MockSdkModule =
  Platform.OS === 'web'
    ? registerWebModule(MockSdk, 'BrillenSdkModule')
    : new MockSdk()

// Not sure whats going on with types here
export default MockSdkModule as unknown as BrillenSdkModuleType
